import {
  useCreateProjectForm
} from "./chunk-PVCBGE2K.js";

// src/project/create.tsx
import { Dialog, Spacer, Text, Title, showModal } from "@lb-lib/ui";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Inner = (props) => {
  let ProjectForm = useCreateProjectForm(props);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Title, { as: "h1", size: "4", weight: "strong", children: "Create Project" }),
    /* @__PURE__ */ jsx(Spacer, { height: "10px" }),
    /* @__PURE__ */ jsx(Text, { size: "2", weight: "medium", color: "gray600", children: "Projects are where you organize your work." }),
    /* @__PURE__ */ jsx(Spacer, { height: "30px" }),
    /* @__PURE__ */ jsx(ProjectForm, { hasCancelButton: false })
  ] });
};
var createProject = (opts) => {
  showModal(({
    dialogProps
  }) => /* @__PURE__ */ jsx(Dialog.Wrapper, { variant: "padded", ...dialogProps, children: /* @__PURE__ */ jsx(Inner, { ...opts }) }));
};

export {
  createProject
};
//# sourceMappingURL=chunk-QYWN3V55.js.map